import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";


gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);


const pageBanner = () => {
  const bannerAnimation = gsap.timeline({
    paused: false,
  });


  bannerAnimation.fromTo(
    ".banner--media .banner__image",
    {
      scale: 2,
      rotate: 10,
      xPercent: 60,
      yPercent: -30,
      autoAlpha: 0,
    },
    {
      scale: 1,
      rotate: 0,
      autoAlpha: 1,
      xPercent: 0,
      yPercent: 0,
      duration: 1.2,
      ease: "power2.inOut",
    }
  )

  bannerAnimation.fromTo(
    ".banner--media .illustrations",
    {
      opacity: 0,
      autoAlpha: 0,
    },
    {
      opacity: 1,
      autoAlpha: 1,
      duration: 1.2,
      ease: "power2.inOut",
    },
    ">-0.4"
  )
  
  bannerAnimation.fromTo(
    ".banner--media-title",
    {
      opacity: 0,
      y: 100,
      autoAlpha: 0,
    },
    {
      opacity: 1,
      y: 0,
      autoAlpha: 1,
      duration: 1.2,
      ease: "power2.inOut",
    },
    ">-0.7"
  )
  
  if ( $('.sidebar .sidebar-menu') ) {
    bannerAnimation.fromTo(
      ".sidebar",
      {
        opacity: 0,
        y: 100,
        autoAlpha: 0,
      },
      {
        opacity: 1,
        y: 0,
        autoAlpha: 1,
        duration: 1.2,
        ease: "power2.inOut",
      },
      ">-0.8"
    ) 
  }

  bannerAnimation.fromTo(
    ".block--one",
    {
      opacity: 0,
      y: 100,
      autoAlpha: 0,
    },
    {
      opacity: 1,
      y: 0,
      autoAlpha: 1,
      duration: 1.2,
      ease: "power2.inOut",
    },
    ">-0.8"
  ) 

  if ( $('.admission-line') ) {
    bannerAnimation.fromTo(
      ".admission-line svg",
      {
        opacity: 0,
        autoAlpha: 0,
        zIndex: -1,
      },
      {
        opacity: 1,
        autoAlpha: 1,
        zIndex: -1,
        duration: 1.2,
        ease: "power2.inOut",
      },
      ">-0.8"
    ) 
  }
  ;


};

  




export default pageBanner;
